<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-heads"><a href="#/f006#s1">Acknowledgments</a></p>
<p class="body-text-drop-cap"><span class="drop-cap">S</span>pecial thanks to my colleagues and friends: Steve Morris  (co-editor and publisher with me of <span class="no-style-override-7">The New Criminologist</span>), Phillip Simpson, Kirstie McCallum, Sarah Brown, Ruth Sands, Simon Beal (webmaster of <span class="no-style-override-7">TNC</span>), my parents, Patrick and May, and Martin Balaam.</p>
<p class="body-text"> Much gratitude is also extended to all of the professionals who have assisted me in the writing of this book. I also mention here the featured individuals who spoke to me.</p>
<p class="body-text"> For John Wayne Gacy: Joseph R Kozenczak, former Chief of Police, Des Plaines PD, Judge Louis B Garippo and attorney William Kunkle. </p>
<p class="body-text"> For Kenneth Bianchi: Frances Piccione (Bianchi’s adoptive mother), Kenneth Bianchi, Veronica ‘VerLyn’ Compton, Professor Donald T Lunde, MA, MD, Professor David Canter, Professor Elliot Leyton, Judge Roger Boren, Bellingham PD, LAPD Homicide, Captain Lynde Johnston, Rochester PD Homicide, Det Richard Crotsley LAPD Homicide, Agent Robert Beams FBI, Katherine Yronwode, Whatcom Security Agency, former SOCO Bellingham PD Robert Knudsen, the staff at Western Washington Correctional Centre for Women (WWCCW) and the Washington State Penitentiary (WSP) Walla Walla. </p>
<p class="body-text"> William Heirens: The Vienna Correctional Centre, Ill, William Heirens, Dolores Kennedy, attorney Thomas Epach and Betty Finn (sister of Suzanne Degnan).</p>
<p class="body-text"> John Cannan: the Avon and Somerset Police, DCI Bryan Saunders, Dorset Police, SO II Metropolitan Police – DCI Jim Dickie and DI Stuart Ault, John Cannan, Professor David Canter, Mrs Cannan, Robin Odell and Sharon Major.</p>
<p class="body-text"> Patricia Wright: Arletta Wright and Patricia Wright.</p>
<p class="body-text"><span class="no-style-override-8">Finally, thanks to all of my staff at www.newcriminologist.co.uk, </span>my publisher John Blake and Lucian Randall, along with the many thousands of readers who enjoyed the prequel to this book: <span class="no-style-override-7">Talking with Serial Killers</span>. </p>
<p class="body-text body-text-override"><span class="no-style-override-8">Christopher Berry-Dee, </span></p>
<p class="body-text body-text-override"><span class="no-style-override-8">Southsea, Hampshire</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f007.vue?12b113fc